export default "__VITE_ASSET__BVXyjdGQ__"